import React from 'react'

export const MobileSVG: React.FC = () => {
  return (
    <svg
      className="icon"
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="16603"
      width="20"
      height="20"
    >
      <path
        d="M716.8 102.4a102.4 102.4 0 0 1 102.4 102.4v614.4a102.4 102.4 0 0 1-102.4 102.4H307.2a102.4 102.4 0 0 1-102.4-102.4V204.8a102.4 102.4 0 0 1 102.4-102.4h409.6z m0 51.2H307.2a51.2 51.2 0 0 0-50.8416 45.2096L256 204.8v614.4a51.2 51.2 0 0 0 45.2096 50.8416L307.2 870.4h409.6a51.2 51.2 0 0 0 50.8416-45.2096L768 819.2V204.8a51.2 51.2 0 0 0-45.2096-50.8416L716.8 153.6z m-128 614.4v51.2h-153.6v-51.2h153.6z"
        fill="#000000"
        p-id="16604"
      ></path>
    </svg>
  )
}

export const PadSVG: React.FC = () => {
  return (
    <svg
      className="icon"
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="16729"
      width="20"
      height="20"
    >
      <path
        d="M819.2 153.6a102.4 102.4 0 0 1 102.4 102.4v512a102.4 102.4 0 0 1-102.4 102.4H204.8a102.4 102.4 0 0 1-102.4-102.4V256a102.4 102.4 0 0 1 102.4-102.4h614.4z m0 51.2H204.8a51.2 51.2 0 0 0-50.8416 45.2096L153.6 256v512a51.2 51.2 0 0 0 45.2096 50.8416L204.8 819.2h614.4a51.2 51.2 0 0 0 50.8416-45.2096L870.4 768V256a51.2 51.2 0 0 0-45.2096-50.8416L819.2 204.8z m0 153.6v307.2h-51.2V358.4h51.2z"
        fill="#000000"
        p-id="16730"
      ></path>
    </svg>
  )
}

export const PcSVG: React.FC = () => {
  return (
    <svg
      className="icon"
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="16887"
      width="20"
      height="20"
    >
      <path
        d="M921.6 768v51.2H102.4v-51.2h819.2zM870.4 204.8v512H153.6V204.8h716.8z m-51.2 51.2H204.8v409.6h614.4V256z"
        fill="#000000"
        p-id="16888"
      ></path>
    </svg>
  )
}
